import { useMutation } from "@tanstack/react-query";
import { client } from "@/api/client";
import { handleError } from "@/api/error";

type ResetPasswordPayload = {
  email: string;
  token: string;
  newPassword: string;
};

export const useResetPassword = () => {
  return useMutation({
    mutationFn: async (payload: ResetPasswordPayload) => {
      const res = await client["reset-password"].$post({
        json: payload,
      });
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
  });
};
